import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

/**
 * The system's « reduce motion » setting, live. On web, react-native-web reads
 * `prefers-reduced-motion`. Starts false and settles after one async read, so
 * a component should decide its choreography when it starts, not at import.
 */
export function useReduceMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    let alive = true;
    AccessibilityInfo.isReduceMotionEnabled?.()
      .then((value) => { if (alive) setReduced(!!value); })
      .catch(() => {});
    const sub = AccessibilityInfo.addEventListener?.('reduceMotionChanged', (value: boolean) => setReduced(!!value));
    return () => {
      alive = false;
      sub?.remove?.();
    };
  }, []);

  return reduced;
}
